import { store } from '../store'
import DynamicModuleRegistrationUtil from '../utils/dynamicModuleRegistration'

// Vuex Modules to load
const PowerBiStoreModule = () =>
  import(/* webpackChunkName: "PowerBiStoreModule" */ '../store/modules/powerBI')

// Components
const PowerBI = () =>
   import(/* webpackChunkName: "PowerBI" */ '@/components/shared/PowerBI')

const dynamicModuleRegistrationLocationsArgs = () => {
  return {
    modulesNamespace: store._modulesNamespaceMap,
    moduleName: 'powerBi',
    module: PowerBiStoreModule,
    store,
    modulePath: 'powerBi'
  }
}

export default [
  {
    path: '/powerBi',
    name: 'PowerBi',
    component: PowerBI,
    beforeEnter (_to, _from, next) {
      DynamicModuleRegistrationUtil(dynamicModuleRegistrationLocationsArgs()).then(
        () => next()
      )
    },
    meta: {showSideNav: false}
  }
]
